<template>
  <footer class="site-footer" v-html="content"></footer>
</template>

<script>
import { renderFooterContent } from "@/content/chrome";

export default {
  data() {
    return { content: renderFooterContent() };
  },
};
</script>
